import { render, staticRenderFns } from "./CampusRecruitmentForm.vue?vue&type=template&id=142eff20&scoped=true"
import script from "./CampusRecruitmentForm.vue?vue&type=script&lang=js"
export * from "./CampusRecruitmentForm.vue?vue&type=script&lang=js"
import style0 from "./CampusRecruitmentForm.vue?vue&type=style&index=0&id=142eff20&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142eff20",
  null
  
)

export default component.exports